import React from 'react';
import { CommonDatePicker } from '../common-date-picker/common-date-picker';
import { subDays, subYears } from "date-fns";
import './styles/index.scss';
export type DateFilterProps = {
    filterData: CMxCommonApp.SharedFilter;
    currentFilter: string | null;
    handleDateChange: (startDate: Date, endDate: Date, presetTypeSelected?: CMxCommonApp.DatePresets) => void;
    filterSelection: {
        [key: string]: boolean | Date;
    };
    defaultFilterSelection: CMxCommonApp.FilterSelection;
};
class DateFilter extends React.Component<
    DateFilterProps
> {
    constructor(props: DateFilterProps) {
        super(props);
        this.handlePresetChange = this.handlePresetChange.bind(this);
        this.handleDateClear = this.handleDateClear.bind(this);
    }

    handlePresetChange(presetType: CMxCommonApp.DatePresets) {
        const today = new Date();
        let startDate, endDate;
        if (presetType.durationType) {
            switch (presetType.durationType) {
                case "days":
                    startDate = subDays(today, presetType.duration);
                    endDate = today;
                    break;
                case "years":
                    startDate = subYears(today, presetType.duration);
                    endDate = today;
                    break;
                default:
                    break;
            }
        } else {
            startDate = presetType.startDate
            endDate = presetType.endDate
        }

        this.props.handleDateChange(startDate, endDate, presetType)
    }

    handleDateClear() {
        const { filterData } = this.props;
        const startDate = filterData?.dateFilterOptions?.startDate;
        const endDate = filterData?.dateFilterOptions?.endDate;
        this.props.handleDateChange(startDate, endDate);
    }

    render() {
        const { filterData, filterSelection } = this.props;
        const startDate = filterSelection?.startDate;
        const endDate = filterSelection?.endDate;
        const { datePresets } = filterData?.dateFilterOptions ?? {};

        return (
            <div className="filter-content date-filter-content">
                {datePresets && <div className="filter-presets">
                    {datePresets.map((datePreset) =>
                        <button
                            key={datePreset.key}
                            onClick={() => this.handlePresetChange(datePreset)}
                            className="chakra-secondary-button date-duration-btn">
                            {datePreset.name}
                        </button>
                    )
                    }
                    <button
                        key="actions-reset"
                        onClick={this.handleDateClear}
                        className="chakra-secondary-button clear-btn">
                        Clear
                    </button>
                </div>}
                <div className="filter-date">
                    <CommonDatePicker
                        startDate={startDate as Date}
                        endDate={endDate as Date}
                        label={''}
                        showRange={true}
                        onSelection={(startDate, endDate) => {
                            if (startDate && endDate) {
                                this.props.handleDateChange(startDate, endDate)
                            }
                            if (!startDate && !endDate) {
                                this.handleDateClear();
                            }
                        }}
                        selectsRange={true}
                    />
                </div>
            </div>
        )
    }
}

export { DateFilter };
